import Avatar from '@mui/material/Avatar';
import { getShortUserName, IUser, setClass } from '@utils';
import React, { FC, ReactElement } from 'react';
import { Cross } from '../svgs';
import { isMobile } from 'react-device-detect';
import '../../styles/components/user.scss';

interface UserProps {
  member: IUser;
  memberStatus?: boolean;
  isSelected: boolean;
  onClickMember?: (memberId: number) => void;
  memberIcon?: ReactElement;
  isHeader?: boolean;
  isMobileSelect?: boolean;
}

/**
 * @param memberStatus - если значение = null, то статус скрывается, если boolean, то будет либо зеленым, либо красным
 * @param member - объект юзера
 * @param isSelected - возвращает булево, выбран ли юзер или нет (при true юзер подсвечивается синим и справа есть крестик, чтобы удалить)
 * @param onClickMember - функция, вызывающаяся при клике на юзера (обычно добавляет или удаляет его из выбранных)
 */
export const User: FC<UserProps> = ({
  member, memberStatus = false, isSelected, onClickMember, memberIcon, isHeader = false, isMobileSelect = false
}) => (
  <div
    key={member.id}
    className="user"
    onClick={onClickMember && (() => onClickMember(member.id))}
  >
    <div className="left-block">
      <div className={setClass("photo", isMobile && 'mobile')}>
        <Avatar
          sx={{ height: '100%', width: '100%' }}
          src={member.img}
        />
      </div>
      <div className={setClass('info', isHeader && 'info-header', isMobileSelect && 'mobile-select')}>
        <div className={setClass('name', isSelected && 'selected')}>
          {getShortUserName(member.fullName)}
        </div>
        <div className="position">
          {member.position}
        </div>
      </div>
    </div>
    {memberStatus && (
    <div className="right-block">
      {memberIcon}
      <div className="delete-user">
        {isSelected && <Cross />}
      </div>
    </div>
    )}
  </div>
);
